'use client';

import dynamic from 'next/dynamic';

const Sonner = dynamic(() => import('sonner').then((mod) => mod.Toaster), { ssr: false });

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  // https://sonner.emilkowal.ski/toast#api-reference
  return (
    <Sonner
      theme="light"
      className="toaster group"
      // maximum 3 toasts are allowed to be viewed at once
      visibleToasts={3}
      // stacks all visible toasts
      expand={false}
      // add a close button
      closeButton={false}
      // Default placement for toasts. (sonner 2.x supports per-toast `position`
      // safely, so individual toast() calls may override this when needed.)
      position="top-right"
      richColors={true}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground'
        }
      }}
      {...props}
    />
  );
};

export { Toaster, type ToasterProps };
